import ReactDOM from "react-dom/client";
import { Provider as StoreProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { NuqsAdapter } from "nuqs/adapters/react-router";
import AppErrorBoundary from "../components/appErrorBoundary";
import { EnvProvider } from "../components/envContext";
import App from "../containers/app";
import { store } from "../state/store";
import { getEnvValueFor } from "../helpers/utils";
import PusherProvider from "../components/pusherProvider";
import DashboardEvents from "../components/dashboardEvents";
import CacheProvider from "../components/cacheProvider";
import PendingResultWaitEvents from "../components/pendingResultWaitEvents";
import initializeSentryErrorReporting from "../services/sentry/init";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "ag-charts-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { LicenseManager } from "ag-grid-enterprise";

// Initialize Vantage global object for developer tools
// Usage in browser console:
//   Vantage.widget_debug_mode = true  // Show reload button & API timing on widgets
(window as any).Vantage = (window as any).Vantage || {};

console.log(`load time: ${(performance.now() / 1000).toFixed(2)}s`);
const rootElement = document.getElementById("root") as HTMLDivElement;
const root = ReactDOM.createRoot(rootElement);

initializeSentryErrorReporting();

LicenseManager.setLicenseKey(getEnvValueFor('TABLE_LICENSE_TOKEN', true) || '');


root.render(
  <AppErrorBoundary>
    <EnvProvider envObject={rootElement.dataset}>
      <PusherProvider>
        <CacheProvider>
          <DashboardEvents>
            <PendingResultWaitEvents>
              <StoreProvider store={store}>
                <BrowserRouter>
                  <NuqsAdapter>
                    <App />
                  </NuqsAdapter>
                </BrowserRouter>
              </StoreProvider>
            </PendingResultWaitEvents>
          </DashboardEvents>
        </CacheProvider>
      </PusherProvider>
    </EnvProvider>
  </AppErrorBoundary>
);
